import { HighScoreRecord } from '../../../app/data/types/high-score-record';

export const loadHighScores = (): HighScoreRecord[] => {
  return JSON.parse(window.localStorage.getItem('highScores') || '[]');
};

export const saveHighScores = (highScores: HighScoreRecord[]) => {
  window.localStorage.setItem('highScores', JSON.stringify(highScores));
};
